import { FilterItem } from 'models';
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import FilterAction from 'redux/actions/filterAction';
import { RootState } from "redux/store";
import { checkEnabledFeature } from 'utils/function';
import { GenerateDataTranslation } from "utils/translation";

export const SortValue = {
  NEWEST: 'Newest',
  OLDEST: 'Oldest',
};

export const useRequestsApprovalFilter = (username: string) => {
    const requestTranslation = GenerateDataTranslation('requests');
    const dispatch = useDispatch();
    const { dataFilterApproval } = useSelector(
      (state: RootState) => state.filterReducer,
    );
    const { permission } = useSelector(
      (state: RootState) => state.configReducer,
    );
    const { delegation } = permission;
    const isDelegationEnabled =
      delegation?.enabled && checkEnabledFeature(delegation);
    const { NEWEST, OLDEST } = SortValue;

    useEffect(() => {
      if (!username) return;
      
      dispatch(FilterAction.getListFilterApproval(username));
    }, [username]);

    const sortData = dataFilterApproval.sort_order ? dataFilterApproval.sort_order.map((i:any) => ({
      label: requestTranslation ? requestTranslation[i.id] : i.id,
      value: i.id
    })) : [{
      label: requestTranslation? requestTranslation[NEWEST] : NEWEST,
      value: NEWEST
    },{
      label: requestTranslation? requestTranslation[OLDEST] : OLDEST,
      value: OLDEST
    }];
    const translatingLabelFilter = (key: string) => {
      let result = dataFilterApproval[key]?.map((item:any) =>{
        return {...item, label: requestTranslation?.filterLabel?.[key]?.[item.id] || item.label}
      }) || dataFilterApproval[key];
      if (!isDelegationEnabled && dataFilterApproval[key]) {
        result = result.filter((item: any) => item.id !== 'delegated');
      }
      return result;
    };

    const requestsFilter: FilterItem[] = [
      {
        label: requestTranslation?.filterLabel?.createdDate,
        childs: translatingLabelFilter('date_range') || [],
        multiple: false,
        keyName: 'created_date',
      }
    ];
    const approvalFilter: FilterItem[] = [
      {
        label: requestTranslation?.filterLabel?.createdDate,
        childs: translatingLabelFilter('date_range')|| [],
        multiple: false,
        keyName: 'created_date',
      },
      {
        label: requestTranslation?.filterLabel?.status?.approvals,
        childs: translatingLabelFilter('approver') || [],
        multiple: false,
        keyName: 'approver',
      }
    ];
    const incidentFilter: FilterItem[] = [
      {
        label: requestTranslation?.filterLabel?.createdDate,
        childs: translatingLabelFilter('date_range') || [],
        multiple: false,
        keyName: 'created_date',
      }
    ];

    return {
        requestsFilter,
        approvalFilter,
        incidentFilter,
        sortData,
    };
}